<template>
  <div id="control-point-logs" class=" custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-row :gutter="24">
            <el-col :span="24" class="mb-2">
              <el-button type="primary" icon="fas fa-search" size="mini" @click="isFilterEnabled = !isFilterEnabled" round>{{ $t("components.automatedmessages.controlPointLogs.filter") }}</el-button>
            </el-col>
            <transition name="el-zoom-in-top" mode="out-in">
              <el-col :span="24" v-if="isFilterEnabled">
                <div class="mb-2 control-point-filter">
                  <div class="filter-body">
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="24">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.automatedmessages.controlPointLogs.search") }}</label>
                          </div>
                          <el-input v-model="filter.participantNo" clearable :placeholder="$t('components.automatedmessages.controlPointLogs.participantNo')"></el-input>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.automatedmessages.controlPointLogs.controlType") }}</label>
                          </div>
                          <el-select v-model="filter.logType" :placeholder="$t('components.automatedmessages.controlPointLogs.all')" clearable @clear="filter.logType = null" filterable>
                            <el-option v-for="(option, index) in getEnums.find(x => x.title == 'ControlPointType').enums" :label="option.displayName" :value="option.key" :key="index"></el-option>
                          </el-select>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.automatedmessages.controlPointLogs.status") }}</label>
                          </div>
                          <el-select v-model="filter.status" :placeholder="$t('components.automatedmessages.controlPointLogs.all')" clearable @clear="filter.status = null" filterable>
                            <el-option v-for="(option, index) in getEnums.find(x => x.title == 'AccessLogStatus').enums" :label="option.displayName" :value="option.key" :key="index"></el-option>
                          </el-select>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="filter-footer d-flex justify-content-between mt-2">
                    <div class="left-buttons">
                      <el-button size="mini" @click="isFilterEnabled = !isFilterEnabled">{{ $t("components.automatedmessages.controlPointLogs.close") }}</el-button>
                    </div>
                    <div class="right-buttons">
                      <el-button size="mini" @click="filterReset" :loading="loading == 'filterReset'" type="primary">{{ $t("components.automatedmessages.controlPointLogs.reset") }}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </transition>
            <el-col :span="24" v-if="items.length > 0">
              <div class="custom-grid-table-header control-point-header">
                <span>{{ $t("components.automatedmessages.controlPointLogs.participant") }}</span>
                <span>{{ $t("components.automatedmessages.controlPointLogs.controlType") }}</span>
                <span>{{ $t("components.automatedmessages.controlPointLogs.checkpoint") }}</span>
                <span>{{ $t("components.automatedmessages.controlPointLogs.status") }}</span>
                <span>{{ $t("components.automatedmessages.controlPointLogs.date") }}</span>
                <span></span>
              </div>
              <div class="control-point-container">
                <div class="item" v-for="item in items" :key="item.id">
                  <!-- <div class="participant-detail">
                    <span>{{ item.participant.title }}</span>
                    <div class="participant-tag">
                      <div class="tag-color" :style="{ 'background-color': item.participant.tag.color }"></div>
                      {{ item.participant.tag.title }}
                    </div>
                  </div> -->

                  <div class="participant-card-mini mini" v-if="item.participant != null && item.participant != undefined">
                    <div class="participant-card-mini-right">
                      <div class="participant-card-mini-title">{{ item.participant.title }}</div>
                      <div class="participant-card-mini-container">
                        <span>
                          <i class="fas fa-circle" :style="{ color: item.participant.tag.color }"></i>
                          <span>{{ item.participant.tag.title }}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <span>
                    {{ getEnumsDisplay("ControlPointType", item.logType) }}
                    <b class="d-block">
                      <i class="fas fa-mobile"></i>
                      {{ item.user != null ? item.user.firstName + " " + item.user.lastName : "" }}
                    </b>
                  </span>
                  <span>{{ item.controlPoint.title }}</span>
                  <span>{{ getEnumsDisplay("AccessLogStatus", item.status) }}</span>
                  <div>{{ $moment(item.createDate).format("DD MMMM YYYY, dddd HH:mm:ss") }}</div>
                  <!-- <div><el-button circle size="mini" type="danger" icon="fas fa-trash"></el-button></div> -->
                  <div>
                    <el-tooltip effect="dark" :content="$t('buttonGeneral.delete')" placement="top">
                      <el-button circle size="mini" :loading="loading == 'deleteLog-' + item.id" type="danger" icon="fas fa-trash" @click="deleteLog(item.id)"></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24" v-else>
              <div>
                <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-access-control-lottie'" :title="$t('event.table.entryRecords')" @btnAdd="false" @btnRefresh="false" :buttonAdd="false" :buttonRefresh="false" :loading="loading" />
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("event.buttons.close") }}</el-button>
      </div>
      <div class="center-buttons" v-if="items.length > 0">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="total,sizes,prev, pager, next" :total="filter.total"></el-pagination>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="openExcellDialog">{{ $t("components.automatedmessages.controlPointLogs.download") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["activeVenue"],
  data() {
    return {
      items: [],
      loading: false,
      timeout: null,
      resetFilter: {
        skip: 0,
        take: 20,
        searchTerm: null,
        ids: [],
        logType: null,
        status: null,
        userId: null,
        total: 0,
        page: 1,
        venueId: null,
        participantId: null,
        liveStreamId: null,
        networkingAreaId: null,
        participantNo: null
      },
      filter: {
        skip: 0,
        take: 20,
        searchTerm: null,
        total: 0,
        page: 1,
        ids: [],
        logType: null,
        status: null,
        userId: null,
        venueId: null,
        participantId: null,
        liveStreamId: null,
        networkingAreaId: null,
        participantNo: null
      },
      isFilterEnabled: false
    };
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  async created() {
    if (this.activeVenue != null && this.activeVenue != undefined) {
      this.filter.venueId = this.activeVenue;
      this.resetFilter.venueId = this.activeVenue;
    }
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.getData();
      this.loading = false;
    }, 500);
  },
  methods: {
    deleteLog(id) {
      this.loading = "deleteLog-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteControlPointAccessLog", id);
        if (!res.data.alert.hasError) {
          await this.getData();
        }
        this.loading = false;
      }, 500);
    },
    openExcellDialog() {
      this.exportXlsx(6, null, JSON.stringify(this.filter));
    },
    getData() {
      this.loading = "filterReset";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getControlPointAccessLogs", this.filter);
        if (!res.data.alert.hasError) {
          this.filter.total = res.data.data.totalCount;
          this.items = res.data.data.items;
        } else {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    },
    filterReset() {
      this.filter = JSON.parse(JSON.stringify(this.resetFilter));
    },
    handleSizeChange(take) {
      this.filter.take = take;
    },
    handleCurrentChange(page) {
      this.filter.page = page;
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getData();
        }, 250);
      }
    }
  }
};
</script>

<style lang="less" scoped>
#control-point-logs {
  .control-point-filter {
    background-color: #f1f1f1;
    border-radius: 8px;
    padding: 8px;
  }
  .control-point-header {
    grid-template-columns: 1fr 1fr 1fr 150px 250px 30px;
  }
  .control-point-container {
    display: flex;
    flex-direction: column;
    .item {
      transition: all 0.5s;
      border-radius: 8px;
      display: grid;
      background-color: #f1f1f1;
      margin-bottom: 8px;
      grid-template-columns: 1fr 1fr 1fr 150px 250px 30px;
      padding: 10px;
      gap: 0.5rem;
      align-items: center;

      &:last-child {
        margin-bottom: unset;
      }
      &.passive {
        background-color: #fff2f2 !important;
      }
      .log-content {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        .message-type {
          text-decoration: underline;
          color: #03658c;
          font-weight: 500;
          font-size: 11px;
        }
        .history {
          font-size: 12px;
          font-weight: 500;
        }
      }
      .participant-detail {
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        .participant-tag {
          display: flex;
          flex-direction: row;
          gap: 0.4rem;
          .tag-color {
            width: 12px;
            height: 12px;
            border-radius: 50%;
          }
          align-items: center;
        }
      }
    }
  }
}
.registration-question {
  width: 100%;
  transition: 1s;
  margin-top: 18px;

  .sub-title {
    color: #292f3b;
    font-weight: 400;
    margin-bottom: 8px;
    font-size: 14px;
  }

  span {
    color: #505763;
    font-size: 13px;
    font-weight: 400;
  }

  .choice-questions {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-date-editor {
    width: 100% !important;
  }

  .rate-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 150px;

    .el-slider {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/automatedmessages/ControlPointLogs.vue